import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Cell } from 'recharts';

const mockData = [
  { region: 'North', sales: 120000 },
  { region: 'South', sales: 95000 },
  { region: 'East', sales: 78000 },
  { region: 'West', sales: 112000 },
];

const COLORS = ['#3b82f6', '#10b981', '#f59e0b', '#8b5cf6'];

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div style={{
        background: '#ffffff',
        border: '1px solid #e5e7eb',
        borderRadius: '8px',
        padding: '10px 14px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        fontFamily: 'Inter, sans-serif'
      }}>
        <p style={{ margin: 0, fontWeight: 600, color: '#374151', fontSize: '13px' }}>{label}</p>
        <p style={{ margin: '4px 0 0', color: '#3b82f6', fontWeight: 700, fontSize: '14px' }}>
          Sales: ${payload[0].value.toLocaleString()}
        </p>
      </div>
    );
  }
  return null;
};

const SalesByRegionChart = () => (
  <ResponsiveContainer width="100%" height={260}>
    <BarChart data={mockData} margin={{ top: 20, right: 20, left: 0, bottom: 5 }}>
      <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" vertical={false} />
      <XAxis dataKey="region" tickLine={false} axisLine={{ stroke: '#cbd5e1' }} tick={{ fill: '#64748b', fontSize: 12 }} />
      <YAxis tickLine={false} axisLine={false} tick={{ fill: '#64748b', fontSize: 12 }} tickFormatter={(val) => `$${val / 1000}k`} />
      <Tooltip content={<CustomTooltip />} />
      <Bar dataKey="sales" radius={[8, 8, 0, 0]} barSize={40}>
        {mockData.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
        ))}
      </Bar>
    </BarChart>
  </ResponsiveContainer>
);

export default SalesByRegionChart;
